import colors from './colors';
const borders = {
  inputs: `3px solid ${colors.secondaryMid};`,
  error: `1px solid ${colors.error};`,
  radius: '0px',
};

export default borders;
